// extracted by mini-css-extract-plugin
export default {"stosks_column":"styles_stosks_column__Dvh-u","link_download":"styles_link_download__VRw0c","text_time":"styles_text_time__166fG"};